import { isWX, isMail, isTel, isInviteCode, isName, isID } from '@/common/reg'
import { checkMobileCode, checkInvitedCode, checkEmailCode } from '@/api/merchant'

// 邀请码验证
const checkInvCode = (value, callback) => {
  return checkInvitedCode({ inviteCode: value }).then(res => {
    if (!res.code) callback()
    else callback(new Error(res.msg))
  })
}

// 手机验证
const checkTelCode = (telForm, callback) => {
  console.log(telForm)
  return checkMobileCode({
    mobile: telForm.contactMobile,
    code: telForm.smsCode
  }).then(res => {
    if (!res.code) callback()
    else callback(new Error(res.msg))
  })
}

// 邮箱验证
const checkEmail = (emailForm, callback) => {
  return checkEmailCode({
    email: emailForm.contactEmail,
    code: emailForm.emailCode
  }).then(res => {
    if (!res.code) callback()
    else callback(new Error(res.msg))
  })
}

export default {
  // RULE: 联系人姓名
  contactUsername: () => [
    { required: true, message: '请填写姓名', trigger: 'blur' },
    { min: 2, max: 30, message: '请输入2-30个字符', trigger: 'blur' },
    {
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('输入姓名'))
        else if (!isName.test(value)) callback(new Error('正确输入姓名，不能包含特殊字符'))
        else callback()
      }
    }
  ],

  // RULE: 职位
  contactPosition: () => [
    { required: true, message: '请填写职位', trigger: 'blur' },
    { min: 2, max: 30, message: '请输入2-30个字符', trigger: 'blur' }
  ],

  contactIdCardType: () => [
    { required: true, message: '请选择证件类型', trigger: 'change' }
  ],
  // RULE: 联系人手机
  contactMobile: () => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写手机号'))
        else if (!isTel.test(value)) callback(new Error('手机号格式错误'))
        else callback()
      }
    }
  ],

  // RULE: 联系人微信
  contactWeixin: () => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写微信号'))
        else if (value.length > 30) callback(new Error('请输入1-30个字符'))
        else if (!isWX.test(value) && !isTel.test(value)) callback(new Error('请输入正确的微信号(手机号)'))
        else callback()
      }
    }
  ],

  // RULE: 联系人邮箱
  contactEmail: () => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写邮箱'))
        else if (!isMail.test(value)) callback(new Error('邮箱格式错误'))
        else callback()
      }
    }
  ],

  // RULE: 联系人身份证号
  contactIdCardNumber: (form) => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写身份证号'))
        if (form.contactIdCardType === 6) {
          callback()// 其他身份证只做非空校验
        } else if (!isID.test(value)) callback(new Error('身份证号格式错误'))
        else callback()
      }
    }
  ],

  // RULE: 邀请码
  contactInviteCode: () => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写邀请码'))
        else if (!isInviteCode.test(value)) callback(new Error('邀请码错误'))
        else checkInvCode(value, callback)
      }
    }
  ],

  // RULE: 图片验证码
  verificationCode: (checkImageCode) => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写验证码'))
        else checkImageCode(value, callback)
      }
    }
  ],

  // RULE: 手机验证码
  smsCode: (telForm) => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写手机验证码'))
        else checkTelCode(telForm, callback)
      }
    }
  ],

  // RULE: 邮箱验证码
  emailCode: (emailForm) => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写验证码'))
        else checkEmail(emailForm, callback)
      }
    }
  ]
}
